module.exports = __webpack_public_path__ + "img/8_49.7661d5e5.png";